import {Base} from "../Base";
import {useContext, useEffect, useState} from "react";
import {GetMyBabyList} from "../api/MyBabyApi";
import {ApiRequestError} from "../api/ApiRequestError";
import {MyBabyInfo} from "../api/response/MyBaby";
import {AppContext} from "../App";
import {Box, Link, List, ListItem, Paper, Table, TableBody, TableCell, TableRow, Typography} from "@mui/material";
import {UserSubHeader} from "../components/UserSubHeader";

export const UserBabyPage = () => {
  const [babies, setBabies] = useState<MyBabyInfo[]>([]);
  const {dispatch} = useContext(AppContext);

  const fetchBabies = async () => {
    try {
      const list = await GetMyBabyList();
      setBabies(list);
    } catch (e: any) {
      if (e instanceof ApiRequestError && e.status === 401) {
        window.location.href = "/pages/login";
      } else {
        dispatch({ type: "setError", payload: { error: true, message: e.message } });
      }
    }
  };

  useEffect(() => {
    fetchBabies();
  }, []);

  const grouped: Record<string, MyBabyInfo[]> = babies.reduce((acc, cur) => {
    if (!acc[cur.server]) acc[cur.server] = [];
    acc[cur.server].push(cur);
    return acc;
  }, {} as Record<string, MyBabyInfo[]>);

  return <Base>
    <UserSubHeader active={"user_baby"}/>
    <Paper>
      <Box p={2}>
        <Typography variant="h6" gutterBottom>マイベイビー</Typography>
        <Table>
          <TableBody>
            {Object.entries(grouped).map(([server, list]) => (
              <TableRow key={server}>
                <TableCell sx={{width: '25%'}} component="th">{server}</TableCell>
                <TableCell>
                  <List>
                    {list.map(baby => (
                      <ListItem key={`${baby.server}-${baby.ID}`} sx={{py:0}}>
                        <Link href={baby.url}>[{baby.ID}] {baby.title || 'タイトルなし'}</Link>
                      </ListItem>
                    ))}
                  </List>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  </Base>;
};
